export const emiService = {
  calculateEMI(loanAmount, tenureYears, interestRate = 6) {
    return calculateEMI(loanAmount, tenureYears, interestRate);
  }
};

export function calculateEMI(loanAmount, tenureYears, interestRate = 6) {
  try {
    // Validate input
    if (
      loanAmount == null ||
      tenureYears == null ||
      isNaN(loanAmount) ||
      isNaN(tenureYears) ||
      loanAmount <= 0 ||
      tenureYears <= 0
    ) {
      return {
        success: false,
        message: 'Please provide a valid loan amount and tenure',
        data: null
      };
    }

    const months = tenureYears * 12;

    // Simple Interest: SI = (P * R * T) / 100
    const totalInterest = (loanAmount * interestRate * tenureYears) / 100;
    const totalAmount = loanAmount + totalInterest;
    const monthlyEMI = totalAmount / months;

    return {
      success: true,
      data: {
        loanAmount: Number(loanAmount),
        interestRate,
        tenureYears: Number(tenureYears),
        tenureMonths: months,
        monthlyEMI: Number(monthlyEMI.toFixed(2)),
        totalInterest: Number(totalInterest.toFixed(2)),
        totalAmount: Number(totalAmount.toFixed(2))
      }
    };
  } catch (error) {
    return {
      success: false,
      message: error.message || 'Something went wrong',
      data: null
    };
  }
}
